const API_BASE = '/api';

export interface MirrorConfig {
  id?: string;
  tenant_id: string;
  source_group_jid: string;
  source_group_name?: string;
  is_active: boolean;
  target_group_ids: string[];
  replace_image: boolean;
  auto_dispatch: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface MirrorEventLog {
  id: string;
  tenant_id: string;
  source_group_jid: string;
  message_id?: string;
  original_text?: string;
  extracted_url?: string;
  resolved_url?: string;
  marketplace?: string;
  product_identifier?: string;
  affiliate_url?: string;
  final_image_url?: string;
  image_source: 'catalog' | 'fallback_original' | 'none' | string;
  status: 'cloned' | 'ignored' | 'failed' | string;
  reason?: string;
  queue_item_id?: string;
  created_at: string;
}

export async function fetchMirrorConfig(token: string): Promise<MirrorConfig> {
  const res = await fetch(`${API_BASE}/mirror/config`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData.detail || 'Falha ao carregar configuração do espelho.'
    );
  }
  return res.json();
}

export async function saveMirrorConfig(
  token: string,
  payload: Partial<MirrorConfig>
): Promise<MirrorConfig> {
  const res = await fetch(`${API_BASE}/mirror/config`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData.detail || 'Falha ao salvar configuração do espelho.'
    );
  }
  return res.json();
}

export async function fetchMirrorLogs(
  token: string,
  limit: number = 50
): Promise<MirrorEventLog[]> {
  const res = await fetch(`${API_BASE}/mirror/logs?limit=${limit}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData.detail || 'Falha ao carregar logs de espelhamento.'
    );
  }
  return res.json();
}

export async function simulateMirrorMessage(
  token: string,
  payload: {
    text: string;
    image_url?: string;
    source_group_jid?: string;
  }
): Promise<Record<string, unknown>> {
  const res = await fetch(`${API_BASE}/mirror/simulate`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(
      errorData.detail || 'Falha ao simular espelhamento de mensagem.'
    );
  }
  return res.json();
}
